/* joacă bună — coș drawer: Cart AJAX API (add/change/remove), focus trap, ESC, overlay, scroll lock.
   Ascultă 'jb:added' (jb-product.js) ca să deschidă drawerul după adăugare. Vanilla, ~2KB. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var panel = document.getElementById('jb-cart-drawer');
  var overlay = root.querySelector('.jb-cartdrawer__overlay');
  var lastFocus = null;
  var busy = false;

  function sectionUrl() {
    var id = root.getAttribute('data-section-id');
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + '?section_id=' + encodeURIComponent(id);
  }

  function focusable() {
    return Array.prototype.slice
      .call(panel.querySelectorAll('a[href], button:not([disabled]), textarea, input, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    lastFocus = document.activeElement;
    panel.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () { root.setAttribute('data-open', ''); });
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var f = focusable();
    if (f.length) f[0].focus();
  }
  function close() {
    root.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    var onEnd = function () { panel.hidden = true; overlay.hidden = true; panel.removeEventListener('transitionend', onEnd); };
    panel.addEventListener('transitionend', onEnd);
    setTimeout(onEnd, 350); // fallback (prefers-reduced-motion: fără tranziție)
    if (lastFocus) lastFocus.focus();
  }

  function refresh(thenOpen) {
    return fetch(sectionUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.getElementById('jb-cart-drawer');
        if (fresh) panel.innerHTML = fresh.innerHTML;
      })
      .catch(function () {})
      .then(function () { if (thenOpen) open(); });
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function changeLine(line, quantity) {
    if (busy) return;
    busy = true;
    root.setAttribute('data-busy', '');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCounts(cart); return refresh(false); })
      .catch(function () {})
      .then(function () { busy = false; root.removeAttribute('data-busy'); });
  }

  function onClick(e) {
    if (e.target.closest('[data-cart-drawer-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); close(); return; }

    var dec = e.target.closest('[data-cart-line-decrease]');
    var inc = e.target.closest('[data-cart-line-increase]');
    var rem = e.target.closest('[data-cart-line-remove]');
    if (!dec && !inc && !rem) return;
    if (busy) return;

    var btn = dec || inc || rem;
    var line = parseInt(btn.getAttribute('data-line'), 10);
    if (rem) { changeLine(line, 0); return; }

    var row = btn.closest('.jb-cartdrawer__item');
    var qtyEl = row && row.querySelector('[data-cart-line-qty]');
    var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
    changeLine(line, Math.max(0, inc ? qty + 1 : qty - 1));
  }

  var noteTimer = null;
  function onChange(e) {
    var el = e.target.closest('[data-cart-note]');
    if (!el) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: el.value })
      }).catch(function () {});
    }, 500);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('jb:added', function () { refresh(true); });

  window.JBCartDrawer = { open: open, close: close, refresh: refresh };
})();
